import { rest } from 'msw';

import { getEndpointUrl } from '@app/mock/utils';

// This is a demo mock endpoint.
// To try it, navigate to http://localhost:3000/eth/mock/puppy
// All the data on that page is being served by the object below

export const example = rest.get(getEndpointUrl('/eth/mock/puppy'), (req, res, ctx) => {
    return res(
        ctx.status(200),
        ctx.json({
            minter: false,
            contract_address: '508ffd6a182e90532b9b6cbca47010dc4ad411c6',
            token_id: '3332',
            token_uri: 'ipfs://QmUenjhiFbDia5NPPMRj9MfVb67Gmou4wLepGGtxu6jWQN/3332.json',
            name: 'MOCK Puppy #3332',
            description: null,
            metadata_complete: true,
            image: 'ipfs://QmPfcWgo8KneXPLipUtwjwwg8qJYL5B8CKerVePYvpx4Es/3332.png',
            animation_url: null,
            one_day_volume: 0.00354,
            one_day_change: 0.0,
            one_day_sales: 4.0,
            one_day_average_price: 0.000885,
            seven_day_volume: 0.00544,
            seven_day_change: 2.022222222222222,
            seven_day_sales: 6.0,
            seven_day_average_price: 0.000906666666666667,
            thirty_day_volume: 0.01582,
            thirty_day_change: -0.8484964566175063,
            thirty_day_sales: 17.0,
            thirty_day_average_price: 0.000930588235294118,
            total_volume: 1.943315359999979,
            total_sales: 734.0,
            total_supply: 7775.0,
            item_count: 0.0,
            num_owners: 819.0,
            average_price: 0.002647568610354195,
            num_reports: 0,
            market_cap: 7.049333333333333,
            floor_price: 0.001,
            category: null,
            blockchain: 'Ethereum',
            verified: false,
            collection_name: 'Hush Puppies NFT Official',
            collection_image: 'https://i.seadn.io/gcs/files/585d5e2197992d7b506a9187128cd46c.png?w=500&auto=format',
            banner_image: 'https://i.seadn.io/gcs/files/f5979195293314dbdc45bb277fe70623.png?w=500&auto=format',
            collection_created_at: '2022-06-12T22:38:16.000180Z',
            collection_description:
                '7777 Adorable Hush Puppies ready to meet their new owners and bring happiness to the blockchain. % of royalties goes to dog shelters/rescues.',
            collection_short_description: null,
            collection_twitter_username: 'hushpuppiesnft',
            collection_instagram_username: 'hushpuppiesnft',
            collection_wiki_url: null,
            is_nsfw: false,
            featured: false,
            token_type: 'ERC721',
            hidden: false,
            attributes: [
                {
                    value: 'orange',
                    trait_type: 'Background',
                },
                {
                    value: 'fur blue heller',
                    trait_type: 'Fur',
                },
                {
                    value: 'body basket',
                    trait_type: 'Body',
                },
                {
                    value: 'eye angry',
                    trait_type: 'Eyes',
                },
                {
                    value: 'head drink helmet',
                    trait_type: 'Head',
                },
                {
                    value: 'mouth no expression',
                    trait_type: 'Mouth',
                },
            ],
            collection_traits: {
                Background: {
                    aqua: 1,
                },
                Body: {
                    'body neck sweater': 1,
                },
                Eyes: {
                    'eye glasses': 1,
                },
                Fur: {
                    'fur brown and white': 1,
                },
                Head: {
                    'head contruction hat': 1,
                },
                Mouth: {
                    'mouth licking lips': 1,
                },
            },
            collection_trait_count: 6,
            mime_type: 'image/png',
        }),
    );
});
